import { render } from "./OtiActions.vue?vue&type=template&id=2dc57f92&scoped=true"
import script from "./OtiActions.vue?vue&type=script&lang=js"
export * from "./OtiActions.vue?vue&type=script&lang=js"

import "./OtiActions.vue?vue&type=style&index=0&id=2dc57f92&lang=scss&scoped=true"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc57f92"]])

export default __exports__